import PropTypes from "prop-types";

export default {
	player: PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		firstName: PropTypes.string,
		lastName: PropTypes.string
	})
};
